import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Style from '../../Styles/Common.module.css';
import Button from '../../Styles/Button.module.css';
import { Link } from "react-router-dom";
import PlaceholderImage from '../../../assest/images/no-img.jpg';
import { useSelector } from 'react-redux';
import { getblogListFormData } from '../../../services/routes.services';
import constants from '../../../services/constants';
import LoginPopup from "../../Common/Login/UserLogin";
import Modal from 'react-bootstrap/Modal';


const ViewPostListingPage = () => {
  const [jobData, setJobData] = useState([]);
  const [loginShow, setLoginShow] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(8);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);

  const { isAuthenticated, token } = useSelector((state) => state.auth);

  const loginCloseHandler = () => setLoginShow(false);

  useEffect(() => {
    if (!isAuthenticated) {
      setLoginShow(true);
    } else {
      setLoading(true);
      getblogListFormData(token)
        .then((res) => {
           const sortedBlogs = res.data.blogs.sort((a, b) =>
          new Date(b.createdAt) - new Date(a.createdAt)
        );
        setJobData(sortedBlogs);
          // setJobData(res.data.blogs);
          setLoading(false);
        })
        .catch((error) => {
          console.error(error);
          setError('Failed to load posts.');
          setLoading(false);
        });
    }
  }, [isAuthenticated, token]);

  if (!isAuthenticated) {
    return loginShow && <LoginPopup onClose={loginCloseHandler} />;
  }

 const filteredPosts = jobData.filter((post) =>
  post?.title?.toLowerCase().includes(searchQuery.toLowerCase())
);

  const totalPages = Math.ceil(filteredPosts.length / itemsPerPage);
  const currentData = filteredPosts.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
const handleShowPopup = (post) => {
  setSelectedPost(post);
  setShowPopup(true);
};
  return (
    <div className="loginView">
    
      <section className={`${Style.clear} ${Style.breadcrumb}`}>
        <Container>
          <Row>
            <Col>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/community">Community</Link></li>
                <li><Link to="/jobs">Post</Link></li>
                <li>View Post Listing</li>
              </ul>
            </Col>
          </Row>
        </Container>
      </section>
      <div className={`${Style.pageTitle} ${Style.marginUp90} ${Style.postPageDM}`}>
        <Container>
          <Row>
            <Col>
              <div className={Style.sectionTitle}>
                <h2>Posts</h2>
              </div>
            </Col>
          </Row>
          <Row>
            <Col className={`${Style.searchArea} ${Style.postffer}`}>
              <div className={Style.searchContainer}>
                <div className={Style.postButton}>
                  <Link to="/post-create" className={Button.greenBtn}>Create Your Posts</Link>
                </div>
                <div className={Style.searchInput}>
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Search posts..."
                  />
                  <button type="button">Search</button>
                </div>
              </div>
            </Col>
          </Row>
          {loading ? (
            <p>Loading...</p>
          ) : error ? (
            <p>{error}</p>
          ) : (
            <Row>
               {currentData.length === 0 ? (
                <Col>
                  <p style={{ textAlign: 'center', fontWeight: 'bold', padding: '20px' }}>No posts found.</p>
                </Col>
                ) : (
              currentData.map((post) => (
                <Col key={post.BlogID} md={3}>
                  <div className={Style.offerElement}>
                    <figure className={Style.PostImage}>
                      {post?.image !=="null" ? (
                            <img
                              src={`${constants.IMAGE_BASE_URL}/blog/${post?.image}`}
                              alt={post?.title || 'Post Image'}
                            />
                          ): <img
                              src={PlaceholderImage}
                              alt={post?.title || 'Post Image'}
                            />
                          }
                    </figure>
                    <div className={Style.offerTitle}>
                      <h5 style={{ whiteSpace: 'normal' }}>{post?.title==="null" ? 'Untitled ':post?.title}</h5>
                      <p style={{
                          whiteSpace: 'normal',
                          wordBreak: 'break-word',
                          overflow: 'hidden',
                          display: '-webkit-box',
                          WebkitLineClamp: 1,
                          WebkitBoxOrient: 'vertical'
                        }}>{post?.description || 'No description provided.'}</p> 
                        <p style={{ cursor: 'pointer',}} onClick={() => handleShowPopup(post)} className={Button.brownBorderBtn}>View More</p>
                    </div>
                    {post.url!== undefined && <button type="button" className={Button.greenBtn}>
                     <Link to={`/post-detail/${post?.url}`}>More Details</Link> 
                    </button>}
                  </div>
                </Col>
              )))}
              <Col md={12}>
                {/* <ul className={Button.flextCenterBtn + " " + Style.pagging}>
                  {[...Array(totalPages).keys()].map((page) => (
                    <li key={page} >
                      <button type="button" onClick={() => setCurrentPage(page + 1)}>{page + 1}</button>
                    </li>
                  ))}
                </ul> */}
                <ul className={`${Button.flextCenterBtn} ${Style.pagging}`}>
                  {/* First Page Arrow */}
                  {currentPage > 1 && (
                    <li>
                      <button type="button" onClick={() => setCurrentPage(1)}>
                        &laquo;
                      </button>
                    </li>
                  )}
                    {/* Previous Arrow */}
                    {currentPage > 1 && (
                      <li>
                        <button type="button" onClick={() => setCurrentPage(currentPage - 1)}>
                           &lsaquo;
                        </button>
                      </li>
                    )}

                    {/* Page numbers: only show current, previous, and next */}
                    {Array.from({ length: totalPages }, (_, i) => i + 1)
                      .filter((page) => 
                        page === 1 || 
                        page === totalPages || 
                        (page >= currentPage - 1 && page <= currentPage + 1)
                      )
                      .map((page, index, array) => (
                        <li key={page}>
                          <button
                            type="button"
                            onClick={() => setCurrentPage(page)}
                            className={page === currentPage ? Style.activePage : ""}
                          >
                            {page}
                          </button>
                          {/* Add ellipsis if needed */}
                          {index < array.length - 1 && array[index + 1] !== page + 1 && (
                            <span>...</span>
                          )}
                        </li>
                      ))}

                    {/* Next Arrow */}
                    {currentPage < totalPages && (
                      <li>
                        <button type="button" onClick={() => setCurrentPage(currentPage + 1)}>
                          &rsaquo;
                        </button>
                      </li>
                    )}
                    {/* Last Page Arrow */}
                    {currentPage < totalPages && (
                      <li>
                        <button type="button" onClick={() => setCurrentPage(totalPages)}>
                          &raquo;
                        </button>
                      </li>
                    )}
                  </ul>

              </Col>
            </Row>
          )}
          <Modal className="postPop" show={showPopup} onHide={() => setShowPopup(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>{selectedPost?.title==="null" ? 'Untitled ':selectedPost?.title}</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <img
      src={selectedPost?.image!=="null" ? `${constants.IMAGE_BASE_URL}/blog/${selectedPost?.image}` : PlaceholderImage}
      alt={selectedPost?.title}
      style={{ width: '100%', marginBottom: '15px', borderRadius: '4px' }}
    />
    <p style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
      {selectedPost?.description || 'No description available.'}
    </p>
  </Modal.Body>
  <Modal.Footer>
    <button className={Button.greenBtn} onClick={() => setShowPopup(false)}>
      Close
    </button>
  </Modal.Footer>
</Modal>

        </Container>
      </div>
    </div>
  );
};

export default ViewPostListingPage;
